import { render, staticRenderFns } from "./fatturepdf.vue?vue&type=template&id=23366ab8&scoped=true&lang=html"
import script from "./fatturepdf.vue?vue&type=script&lang=js"
export * from "./fatturepdf.vue?vue&type=script&lang=js"
import style0 from "./fatturepdf.vue?vue&type=style&index=0&id=23366ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23366ab8",
  null
  
)

export default component.exports